var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeku(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "45.996 32.7 80.429 83.058",
    width: 80.429,
    height: 83.058,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#67c39b;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#3e5d6b;}"))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124,98.51V51.78a4.83,4.83,0,1,0-5.76-7.69L91.68,36.3a4.82,4.82,0,0,0-9.31-.06L54.13,44.13a4.77,4.77,0,0,0-3.31-1.32,4.84,4.84,0,0,0-2,9.24V98.24A4.83,4.83,0,1,0,54.3,106l28.14,6.43a4.82,4.82,0,0,0,9.32-.6l26-6.22a4.83,4.83,0,1,0,6.3-7.09ZM83.71,41.06a4.79,4.79,0,0,0,6.56,0l21.25,6.22L90.51,52a4.82,4.82,0,0,0-7,0l-22.2-4.72ZM55.4,101.12a4.81,4.81,0,0,0-2.58-2.88V76.89L68,79.7A4.85,4.85,0,0,0,70,82.17v22.29Zm35.42,6.81a4.79,4.79,0,0,0-7.28-.39L75,105.6V82.12a4.83,4.83,0,1,0-6.12-7.33l-16.1-3V52.05A4.94,4.94,0,0,0,54.35,51l28.11,6a4.81,4.81,0,0,0,9.12,0L118.05,51a4.71,4.71,0,0,0,1,.79V71.92L103.9,74.86a4.76,4.76,0,0,0-3.16-1.21,4.83,4.83,0,0,0-2.5,9v23.53Zm12.42-25.31a4.83,4.83,0,0,0,2.18-3L119,77v21.5a4.82,4.82,0,0,0-2.25,3.21L103.24,105Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeku);
export default __webpack_public_path__ + "static/media/teku.4623e6d62f1790a2ed737a35d7d4327d.svg";
export { ForwardRef as ReactComponent };